<template>
    <svg
        id="but_vip"
        xmlns="http://www.w3.org/2000/svg"
        width="19.283"
        height="23.112"
        viewBox="0 0 19.283 23.112"
    >
        <path
            id="Subtraction_6"
            data-name="Subtraction 6"
            d="M2909.11-486.439a2,2,0,0,1-.519-.069l-9.66-2.588a1.985,1.985,0,0,1-1.214-.932,1.986,1.986,0,0,1-.2-1.517l3.624-13.523a2,2,0,0,1,1.93-1.483,2.007,2.007,0,0,1,.519.069l9.659,2.588a1.985,1.985,0,0,1,1.215.931,1.988,1.988,0,0,1,.2,1.517l-3.624,13.523A2,2,0,0,1,2909.11-486.439Zm-5.712-15.21.812,9.827,1.658.444,5.617-8.1-1.481-.4-4.529,6.755-.037-.01-.558-8.117-1.481-.4Z"
            transform="translate(-2895.45 509.551)"
            fill="#854b97"
        />
        <path
            id="Subtraction_5"
            data-name="Subtraction 5"
            d="M2898.521-489.256h0a2.012,2.012,0,0,1-1-2.288l3.624-13.523a2,2,0,0,1,1.93-1.483,2.008,2.008,0,0,1,.519.069l9.659,2.588a2.009,2.009,0,0,1,1.47,2.16,2.015,2.015,0,0,0-.412-.16l-9.659-2.588a2.005,2.005,0,0,0-.519-.069,2,2,0,0,0-1.93,1.483l-3.623,13.523a1.989,1.989,0,0,0-.055.288Z"
            transform="translate(-2897.45 506.551)"
            fill="#854b97"
        />
    </svg>
</template>
